import { coreGetContent } from "../core";
import { buildHotelLookupPath } from "./buildHotelLookupPath";

export const fetchHotelDetailsFromCore = async (
  crsCode: string,
  source?: any | undefined
): Promise<any> => {
  const apiUrl = buildHotelLookupPath("crs_code", crsCode);
  const data = await coreGetContent(apiUrl, source);

  return data;
};

export default fetchHotelDetailsFromCore;
